export type ExperienceItem = {
    year: string;
    role: string;
    company: string;
    description: string;
    backDescription: string;
    achievements: string[];
};

export type ExperienceMock = {
    title: string;
    subtitle: string;
    experiences: ExperienceItem[];
    ctaBlock: {
        title: string;
        subtitle: string;
        buttonLabel: string;
    };
};

export const experienceMock: ExperienceMock = {
    title: 'Experience',
    subtitle: 'Professional growth through product and agency development',
    experiences: [
        {
            year: 'May 2025 – Present',
            role: 'Front-End Developer',
            company: 'NEXTCODE',
            description:
                'Front-End Developer in a product company operating in the iGaming industry. Developing scalable Next.js applications with Strapi CMS integration, focusing on performance, reusable architecture, and responsive UI.',
            backDescription:
                'Working as a Front-End Developer in a product company specializing in interactive gaming platforms within the iGaming industry. Contributing to the development of slot-based products powered by proprietary mathematical models and custom gameplay mechanics. Responsible for building and maintaining scalable front-end applications using Next.js, integrating Strapi CMS for dynamic content management, and implementing reusable UI components with a clean architecture approach. Collaborating across cross-functional and distributed teams to deliver new features and continuous product improvements. Strong focus on performance optimization, maintainability, scalability, and cross-browser compatibility.',
            achievements: [
                'Development of SSR/SPA applications with Next.js',
                'Strapi CMS integration and customization',
                'Reusable component architecture',
                'Responsive UI implementation (HTML, SCSS)',
                'Performance optimization and refactoring',
                'Cross-team collaboration using Git workflows',
            ],
        },
        {
            year: 'Dec 2023 – Apr 2025',
            role: 'Middle Full-Stack Developer',
            company: 'GOODFACE',
            description:
                'Middle Full-Stack Developer focused on fintech projects, complex UI solutions, and animation-heavy interfaces.',
            backDescription:
                'Worked as a Middle Full-Stack Developer with a primary focus on fintech projects. Delivered complex and highly customized design solutions that required advanced animation logic and thoughtful application architecture. Contributed to building a reusable UI component library using Storybook. Worked with WordPress-based solutions alongside modern React and Next.js applications. Participated in both team-based development using Git workflows and independent project delivery. Enhanced expertise in Canvas and SVG animations while solving performance and architectural challenges.',
            achievements: [
                'React and Next.js application development',
                'Redux state management',
                'WordPress development and customization',
                'UI component library development with Storybook',
                'Canvas and SVG animations',
                'Team collaboration with Git',
                'MySQL and PHP integration',
            ],
        },
        {
            year: 'Apr 2023 – Dec 2023',
            role: 'Junior Full-Stack Developer',
            company: 'GOLEM AGENCY',
            description: 'Junior Full-Stack Developer working with CMS platforms and Laravel-based web applications.',
            backDescription:
                'Worked as a Junior Full-Stack Developer contributing to CMS-driven and custom web projects. Gained hands-on experience with Craft CMS, WordPress, and October CMS while also developing static websites. Participated in Laravel projects involving both collaborative and independent development. Contributed to building a platform with user registration, custom admin panel functionality, and extended business logic. Strengthened backend and database integration skills alongside front-end development.',
            achievements: [
                'Laravel application development',
                'CMS development (Craft, WordPress, October)',
                'WooCommerce customization',
                'Custom admin panel implementation',
                'Database integration (MySQL)',
                'Git-based team workflow',
            ],
        },
        {
            year: 'Nov 2022 – Mar 2023',
            role: 'Junior Full-Stack Developer',
            company: 'VOLDES AGENCY',
            description:
                'Junior Full-Stack Developer in a team-based office environment working on diverse commercial projects.',
            backDescription:
                'Started professional career as a Junior Full-Stack Developer in an office-based team environment. Contributed to various commercial projects, including e-commerce platforms and corporate presentation websites. Collaborated closely with developers and designers to deliver functional and maintainable solutions. Improved expertise in WordPress, PHP, and MySQL while handling diverse tasks requiring analytical thinking and creative problem-solving. Delivered solutions such as booking systems and service-based platforms.',
            achievements: [
                'WordPress development',
                'E-commerce implementation',
                'Booking system functionality',
                'PHP and MySQL integration',
                'Front-end development (HTML, CSS, JavaScript)',
                'Team collaboration and Git workflow',
            ],
        },
        {
            year: 'May 2022 – Present',
            role: 'Front-End Developer',
            company: 'FREELANCE',
            description:
                'Freelance Front-End Developer delivering static websites and CMS-based solutions for direct clients.',
            backDescription:
                'Began professional journey as a freelance Front-End Developer to gain commercial experience and practical development skills. Initially focused on static website development using HTML, CSS, and JavaScript, later expanding into WordPress-based projects. Gradually transitioned to more complex tasks involving custom functionality and performance optimization. Over time, established long-term client relationships and began working directly with clients without freelance platforms.',
            achievements: [
                'Static website development',
                'WordPress implementation and customization',
                'Build tools configuration (Gulp, Webpack)',
                'Client communication and requirement analysis',
                'Performance optimization',
            ],
        },
    ],
    ctaBlock: {
        title: 'Let’s Build Something Meaningful',
        subtitle: 'Open to new product challenges and collaborations',
        buttonLabel: 'Contact Me',
    },
};
